import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { textVariants } from '@freelancer/ui/tailwind-text';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  standalone: false,
  selector: 'fl-label',
  template: `
    <span [class]="cls">
      <label [attr.for]="for"> <ng-content></ng-content> </label>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent implements OnInit, OnChanges {
  /** This is for accessibility. ID of the input that this label is associated */
  @Input() for: string;
  @Input() size: TextSize = TextSize.XSMALL;
  @Input() sizeTablet?: TextSize;
  @Input() sizeDesktop?: TextSize;
  @Input() weight = FontWeight.NORMAL;
  @Input() color = FontColor.FOREGROUND;

  cls: string;

  ngOnInit(): void {
    this.computeClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      'size' in changes ||
      'sizeTablet' in changes ||
      'sizeDesktop' in changes ||
      'weight' in changes ||
      'color' in changes
    ) {
      this.computeClasses();
    }
  }

  private computeClasses(): void {
    this.cls = textVariants({
      color: this.color,
      size: this.size,
      sizeTablet: this.sizeTablet,
      sizeDesktop: this.sizeDesktop,
      weight: this.weight,
    });
  }
}
